var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.0) scale(1.230769)"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75 0C7.82 0 5.93 0.57 4.33 1.64C2.72 2.71 1.48 4.23 0.74 6.01C0 7.8 -0.19 9.76 0.18 11.65C0.56 13.54 1.49 15.28 2.85 16.64C4.21 18 5.95 18.93 7.84 19.31C9.73 19.68 11.69 19.49 13.48 18.75C15.26 18.01 16.78 16.77 17.85 15.16C18.92 13.56 19.5 11.67 19.5 9.75C19.49 7.16 18.46 4.68 16.64 2.85C14.81 1.03 12.33 0 9.75 0ZM16.48 4.99L10.5 8.45L10.5 1.53C11.68 1.64 12.84 2 13.87 2.6C14.9 3.2 15.79 4.01 16.48 4.99ZM9 1.53L9 9.31L2.26 13.2C1.7 12 1.44 10.69 1.51 9.37C1.57 8.05 1.94 6.76 2.6 5.62C3.26 4.48 4.19 3.51 5.3 2.8C6.41 2.08 7.68 1.65 9 1.53ZM9.75 18C8.42 17.99 7.12 17.68 5.95 17.07C4.78 16.46 3.77 15.58 3.01 14.5L17.23 6.29C17.81 7.54 18.07 8.93 17.97 10.31C17.88 11.69 17.44 13.02 16.69 14.19C15.95 15.36 14.92 16.32 13.71 16.98C12.49 17.65 11.13 17.99 9.75 18Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefIcon);
export default __webpack_public_path__ + "static/media/refIcon.89db9313ed61dfe842798b1df38f342a.svg";
export { ForwardRef as ReactComponent };